<template>
  <section class="confirm-invitation">
    <div
      class="confirm-invitation__invitation"
      v-if="invitation && !error.type && !isLoading"
    >
      <div class="confirm-invitation__people">
        <div
          class="confirm-invitation__people__wrapper"
          :style="getCircleDiameter"
        >
          <div
            class="confirm-invitation__user confirm-invitation__ballon"
            :style="
              `${getBallonPosition(0)} background-color: ${
                randomColor(profile.first_name || 'any').dark
              };`
            "
          >
            <img
              v-if="notDefault(currentAvatar)"
              :src="currentAvatar"
              class="confirm-invitation__user__image"
              alt="Icon representing the user"
            />
            <img
              v-else-if="notDefault(invitation.invited_by.avatar)"
              :src="invitation.invited_by.avatar"
              class="confirm-invitation__user__image"
              alt="Icon representing the user"
            />
            <span
              v-else
              class="confirm-invitation__user__letter"
              :style="
                `color: ${randomColor(profile.first_name || 'any').lighter}`
              "
              >{{ nameLetters(profile) }}</span
            >
          </div>
          <div
            class="confirm-invitation__member confirm-invitation__ballon"
            v-for="(member, index) in members"
            :key="fullName(member)"
            :style="
              `${getBallonPosition(index + 1)} background-color: ${
                randomColor(member.first_name).dark
              };`
            "
          >
            <img
              class="confirm-invitation__member__image"
              v-if="notDefault(member.avatar)"
              :src="member.avatar"
              :alt="fullName(member)"
            />
            <span
              class="confirm-invitation__member__letter"
              :style="`color: ${randomColor(member.first_name).lighter}`"
              v-else
              >{{ nameLetters(member) }}</span
            >
          </div>
          <div
            v-if="moreMembers"
            class="confirm-invitation__member confirm-invitation__ballon"
            :style="`${getBallonPosition(5)} background-color: #111a27;`"
          >
            <span
              class="confirm-invitation__member__letter confirm-invitation__member__quantity"
              >+{{ invitation.team.members_count - 4 }}</span
            >
          </div>
          <div
            v-if="members.length < 2"
            class="confirm-invitation__account confirm-invitation__ballon"
            :style="
              `${
                invitation.account.logo_url
                  ? `background-image: url('${invitation.account.logo_url}');`
                  : ''
              } background-color: ${
                randomColor(invitation.account.name).light
              }; ${getBallonPosition(1)};`
            "
          >
            <DefaultCompanyAccountLogo
              class="confirm-invitation__account__default"
              v-if="!invitation.account.logo_url"
            />
          </div>
        </div>
      </div>
      <div class="confirm-invitation__messages">
        <Title
          header="Would you like to accept this invite?"
          :tagline="invitationText"
        />
      </div>
      <button
        class="btn btn--primary confirm-invitation__btn"
        type="submit"
        @click="acceptInvitation"
      >
        Accept invite
      </button>
    </div>
    <div class="confirm-invitation__error" v-if="error.type">
      <ErrorInvites v-if="error.type === 'error'" />
      <InfoInvites v-if="error.type === 'info'" />
      <h3 class="confirm-invitation__error__title">Something went wrong!</h3>
      <div class="confirm-invitation__error__message">{{ error.message }}</div>
    </div>
    <div v-if="isLoading" class="confirm-invitation__spinner-wrapper">
      <ActionLoader />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import CONSTANTS from '@/constants'
import Title from '@/components/forms/elements/Title.vue'
import DefaultCompanyAccountLogo from '@/assets/images/business/default-company-account.svg'
import ErrorInvites from '@/assets/icons/business/error_icon_invites.svg'
import InfoInvites from '@/assets/icons/business/info_icon_invites.svg'
import ActionLoader from '@/components/shared/ActionLoader.vue'

export default {
  name: 'ConfirmInvitation',
  components: {
    Title,
    DefaultCompanyAccountLogo: {
      ...DefaultCompanyAccountLogo,
      name: 'DefaultCompanyAccountLogo',
    },
    ErrorInvites: { ...ErrorInvites, name: 'ErrorInvites' },
    InfoInvites: { ...InfoInvites, name: 'InfoInvites' },
    ActionLoader,
  },
  metaInfo() {
    return {
      title: `INE - Invite Confirmation`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      isLoading: false,
      circleDiameter: [
        {
          width: '173px',
          height: '173px',
        },
        {
          width: '250px',
          height: '250px',
        },
        {
          width: '265px',
          height: '265px',
        },
      ],
      positions: [
        [
          {
            left: '-25%',
            top: '-10%',
          },
          {
            right: '-30%',
            bottom: '-10%',
          },
        ],
        [
          {
            left: '-25%',
            top: '-10%',
          },
          {
            right: '-30%',
            bottom: '-10%',
          },
          {
            left: '-25%',
            top: '0',
          },
        ],
        [
          {
            left: '-7%',
            top: '0',
          },
          {
            right: '-10%',
            bottom: '25%',
            width: '115px',
            height: '115px',
          },
          {
            left: '20%',
            top: '60%',
            width: '100px',
            height: '100px',
          },
        ],
        [
          {
            left: '15%',
            top: '-10%',
          },
          {
            right: '-15%',
            bottom: '30%',
            width: '115px',
            height: '115px',
          },
          {
            left: '-5%',
            top: '45%',
            width: '100px',
            height: '100px',
          },
          {
            left: '40%',
            top: '60%',
            width: '86px',
            height: '86px',
          },
        ],
        [
          {
            left: '15%',
            top: '-10%',
          },
          {
            right: '-15%',
            bottom: '30%',
            width: '115px',
            height: '115px',
          },
          {
            left: '-5%',
            top: '45%',
            width: '100px',
            height: '100px',
          },
          {
            left: '70%',
            top: '75%',
            width: '86px',
            height: '86px',
          },
          {
            left: '40%',
            top: '50%',
            width: '75px',
            height: '75px',
          },
        ],
        [
          {
            left: '15%',
            top: '-10%',
          },
          {
            right: '-15%',
            bottom: '30%',
            width: '115px',
            height: '115px',
          },
          {
            left: '-5%',
            top: '45%',
            width: '100px',
            height: '100px',
          },
          {
            left: '35%',
            top: '80%',
            width: '86px',
            height: '86px',
          },
          {
            left: '40%',
            top: '45%',
            width: '75px',
            height: '75px',
          },
          {
            left: '74%',
            top: '75%',
            width: '57px',
            height: '57px',
          },
        ],
      ],
      error: {
        type: null,
        message: null,
      },
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      invitation: state => state.business.invitationInfo,
      profile: state => state.auth.userProfile,
      currentAvatar: state => state.auth.currentAvatar,
    }),
    isBusinessTeamManager() {
      return this.invitation.role === CONSTANTS.ROLES.TEAM_ADMIN
    },
    isAccoundOwner() {
      return this.invitation.role === CONSTANTS.ROLES.ACCOUNT_ADMIN
    },
    members() {
      return this.invitation.team?.members?.length > 1
        ? this.invitation.team.members.slice(0, 4)
        : []
    },
    moreMembers() {
      return this.invitation.team?.members?.length > 4 || false
    },
    userName() {
      const {
        profile: { first_name, last_name },
      } = this
      return `${first_name} ${last_name}`
    },
    colors() {
      const colors = Object.values(CONSTANTS.PROFILE_COLORS)
      return colors
    },
    getCircleDiameter() {
      let diameter = this.circleDiameter[this.circleDiameter.length - 1]
      if (!this.members.length) {
        diameter = this.circleDiameter[0]
      }
      if (this.members.length > 0 && this.members.length < 4) {
        diameter = this.circleDiameter[1]
      }
      const list = Object.entries(diameter)
      let styles = ''
      list.map(([key, value]) => {
        styles += `${key}: ${value};`
      })
      return styles
    },
    invitationText() {
      if (this.isAccoundOwner) {
        return `Join as Account Owner on ${this.invitation.account?.name}'s account.`
      }

      const membersAccount = this.invitation.account?.members_count || 0

      let text = `Join ${this.fullName(this.invitation.invited_by)}`

      if (!this.invitation.team) {
        if (membersAccount > 1) {
          text += ` and ${membersAccount} others`
        }

        text += ` on ${this.invitation.account?.name} account.`
      } else {
        const membersTeam = this.invitation.team?.members_count || 0

        if (membersTeam > 1) {
          text += ` and ${membersTeam} others`
        }

        text += ` ${
          this.isBusinessTeamManager ? 'as Team Manager' : 'as a member'
        } of ${this.invitation.team.name} team.`
      }

      return text
    },
    successText() {
      if (this.invitation.team && this.isBusinessTeamManager) {
        return `Congratulations! You joined the ${this.invitation.account?.name} ${this.invitation.team?.name} team as a manager.`
      }
      if (this.invitation.team) {
        return `Congratulations! You joined the ${this.invitation.account?.name} ${this.invitation.team?.name} team.`
      }
      return `Congratulations! You're part of ${this.invitation.account?.name}'s account.`
    },
  },
  methods: {
    nameLetters({ first_name }) {
      return `${first_name?.substring(0, 1) || 'N'}`
    },
    fullName({ first_name, last_name }) {
      return `${first_name} ${last_name}`
    },
    notDefault(image) {
      return image?.indexOf('default') === -1
    },
    randomColor(str) {
      try {
        const color = this.colors[
          Math.floor(this.seededRandom(str) * this.colors.length)
        ]
        return color
      } catch (error) {
        return this.colors[0]
      }
    },
    getBallonPosition(elementPosition) {
      try {
        const positionIntoArray =
          this.invitation.team?.members?.length > 5
            ? 5
            : this.invitation.team?.members?.length || 0
        const list = Object.entries(
          this.positions[positionIntoArray][elementPosition]
        )
        let styles = ''
        list.map(([key, value]) => {
          styles += `${key}: ${value};`
        })
        return styles
      } catch (error) {
        this.$store.dispatch('app/Error', error)
      }
    },
    async acceptInvitation() {
      const {
        profile: { uaaId: uaa_id },
      } = this
      try {
        this.isLoading = true
        await this.$store.dispatch('business/acceptInvitation', {
          id: this.invitation.id,
          uaa_id,
        })
        await this.$store.dispatch('business/getBusinessUser')
        this.$store.dispatch('app/setSuccess', this.successText)
        this.$router.push({ name: 'home' })
      } catch (error) {
        this.$store.dispatch('app/Error', error)
        this.isLoading = false
      }
    },
    seededRandom(str) {
      let r = this.convertLetterToNumber(str)
      const v = r * Math.PI
      // eslint-disable-next-line no-bitwise
      r = v - (v | 0)
      if (r > 1) r = parseFloat(`0.${r}`)
      return r
    },
    convertLetterToNumber(str) {
      let out = 0
      const len = str.length
      for (let pos = 0; pos < len; pos++) {
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1)
      }
      return Math.abs(out)
    },
    checkErrors() {
      if (
        this.invitation?.user_invite &&
        this.invitation?.user_invite.email !== this.profile.email
      ) {
        this.error.type = 'error'
        this.error.message = `You're currently signed in as ${this.profile.email}. To accept this invitation, sign in using ${this.invitation?.user_invite?.email}.`
      }
      if (
        this.invitation?.user_invite &&
        this.invitation?.user_invite.is_active
      ) {
        this.error.type = 'info'
        this.error.message = `You've already accepted this invite, ${this.profile.first_name}.`
      }
    },
  },
  async mounted() {
    this.invitationId = this.$route.params?.id
    this.$store.dispatch('business/setBusinessInvitationId', '')
    if (!this.isAuthenticated) {
      return this.$router.push({
        name: 'invitation-landing',
        params: { id: this.invitationId },
      })
    }
    this.isLoading = true
    try {
      await this.$store.dispatch('business/getInvitation', {
        id: this.invitationId,
      })
      this.checkErrors()
      this.isLoading = false
    } catch (error) {
      this.error.type = 'error'
      this.error.message = 'This invite is no longer valid.'
      this.isLoading = false
    }
  },
}
</script>

<style lang="scss" scoped>
.confirm-invitation {
  padding-top: 50px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-bottom: 100px;
  background-image: url('../assets/images/backgrounds/dashboard_bg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  height: 100vh;
  min-height: 800px;
  @include tablet {
    padding-top: 100px;
  }
  @include desktop {
    padding-top: 250px;
  }
  &__invitation {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  &__people {
    flex: 1 0 100%;
    width: 100%;
    padding-bottom: 50px;
    img {
      width: 100%;
    }
    &__wrapper {
      position: relative;
      margin: 0 auto;
      width: 250px;
      height: 250px;
      border-radius: 50%;
      background: linear-gradient(
        104.99deg,
        rgba(62, 63, 73, 0.7) -13.91%,
        rgba(62, 63, 73, 0) 100.48%
      );
      mix-blend-mode: normal;
    }
  }
  &__ballon {
    position: absolute;
  }
  &__user,
  &__member,
  &__account {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid var(--white);
    display: flex;
    justify-content: center;
    align-items: center;
    &__default {
      width: 100%;
      height: 100%;
    }
    &__letter {
      font-size: rem(64px);
      font-weight: bold;
      font-family: var(--font-bold);
    }
    &__quantity {
      font-size: rem(17px);
      color: var(--white);
    }
  }
  &__messages {
    width: 100%;
  }
  &__error {
    text-align: center;
    &__title {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: rem(24px);
      line-height: 32px;
      color: var(--white);
    }
    &__message {
      font-size: rem(16px);
      line-height: 24px;
      color: var(--light-blue-gray);
    }
  }
}
</style>
